module.exports = __webpack_public_path__ + "img/marmelaedchen-gaense_xs.fdc3dc8d.jpg";